import { SpringAPI } from 'defs/http/api';
import axios from 'helper/axios-facade';

export const fetchHallOfFame = () => {
	return axios.get(SpringAPI.mySuccess.getMySuccess());
};

export const fetchAllLevels = () => {
	return axios.get(SpringAPI.mySuccess.getLevels());
};
